import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from 'react-skeleton-loader';


function AssignmentListLoader(props) {
    const classes = useStyles();
    return (
        <div className={classes.wrapper}>
            <div className={classes.cntr}>
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
            </div>
            <div className={classes.cntr}>
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
            </div>
            <div className={classes.cntr}>
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
            </div>
            <div className={classes.cntr}>
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
            </div>
            <div className={classes.cntr}>
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
            </div>
            <div className={classes.cntr}>
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
            </div>
            <div className={classes.cntr}>
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
            </div>
            <div className={classes.cntr}>
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
            </div>
            <div className={classes.cntr}>
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
                <Skeleton widthRandomness={0} height="40px" width="100%" color="#ccc" />
            </div>
        </div>
    )
}
const useStyles = makeStyles({
    wrapper: {
        width: '80%'
    },
    cntr: {
        marginTop: '1rem'
    },
    txtWrapper: {
        width: '80%'
    }
})

export default AssignmentListLoader;